import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 312px;
  width: 100%;
  max-width: 1128px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  position: relative;

  .swiper-button-next,
  .swiper-button-prev {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 9;
    width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover:after {
      border: solid #745ef6;
      border-width: 0 6px 6px 0;
    }
  }
  .swiper-button-next.swiper-button-disabled,
  .swiper-button-prev.swiper-button-disabled {
    opacity: 0.35;
    cursor: auto;
    pointer-events: none;
  }
  .swiper-button-next.swiper-button-hidden,
  .swiper-button-prev.swiper-button-hidden {
    opacity: 0;
    cursor: auto;
    pointer-events: none;
  }
  .swiper-navigation-disabled .swiper-button-next,
  .swiper-navigation-disabled .swiper-button-prev {
    display: none !important;
  }
  .swiper-button-next:after,
  .swiper-button-prev:after {
    border: solid #1a055d;
    border-width: 0 6px 6px 0;
    display: inline-block;
    padding: 8px;
  }
  .swiper-button-prev,
  .swiper-rtl .swiper-button-next {
    left: 24px;
    right: auto;
  }
  .swiper-button-prev:after,
  .swiper-rtl .swiper-button-next:after {
    content: '';
    transform: rotate(135deg);
  }
  .swiper-button-next,
  .swiper-rtl .swiper-button-prev {
    right: 24px;
    left: auto;
  }
  .swiper-button-next:after,
  .swiper-rtl .swiper-button-prev:after {
    content: '';
    transform: rotate(-45deg);
  }
  .swiper-button-lock {
    display: none;
  }

  .swiper-pagination {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transition: 300ms opacity;
    transform: translateX(-50%);
    z-index: 10;
    &.swiper-pagination-hidden {
      opacity: 0;
    }
    .swiper-pagination-disabled > &,
    &.swiper-pagination-disabled {
      display: none !important;
    }
  }
  /* Common Styles */
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: 0;
    left: 0;
    width: 100%;
  }

  /* Bullets */
  .swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0;
    .swiper-pagination-bullet {
      transform: scale(0.33);
      position: relative;
    }
    .swiper-pagination-bullet-active {
      transform: scale(1);
    }
    .swiper-pagination-bullet-active-main {
      transform: scale(1);
    }
    .swiper-pagination-bullet-active-prev {
      transform: scale(0.66);
    }
    .swiper-pagination-bullet-active-prev-prev {
      transform: scale(0.33);
    }
    .swiper-pagination-bullet-active-next {
      transform: scale(0.66);
    }
    .swiper-pagination-bullet-active-next-next {
      transform: scale(0.33);
    }
  }
  .swiper-pagination-bullet {
    position: relative;
    height: 40px;
    width: 32px;
    margin-left: 6px;
    margin-right: 6px;
    border-radius: 4px;
    display: inline-block;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 4px;
      width: 24px;
      background-color: #aaa0fa;
    }

    &:focus {
      border: 2px solid #5b36f2;
    }

    .swiper-pagination-clickable & {
      cursor: pointer;
    }

    &:only-child {
      /* display: none !important; */
    }
  }

  .swiper-pagination-bullet-active::before {
    background-color: #1a055d;
  }

  .swiper-vertical > .swiper-pagination-bullets,
  .swiper-pagination-vertical.swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    transform: translate3d(0px, -50%, 0);
    .swiper-pagination-bullet {
      margin: 6px 0;
      display: block;
    }
    &.swiper-pagination-bullets-dynamic {
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      .swiper-pagination-bullet {
        display: inline-block;
        transition: 200ms transform, 200ms top;
      }
    }
  }
  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-horizontal.swiper-pagination-bullets {
    .swiper-pagination-bullet {
      margin: 0 6px;
    }
    &.swiper-pagination-bullets-dynamic {
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      .swiper-pagination-bullet {
        transition: 200ms transform, 200ms left;
      }
    }
  }
  .swiper-horizontal.swiper-rtl
    > .swiper-pagination-bullets-dynamic
    .swiper-pagination-bullet {
    transition: 200ms transform, 200ms right;
  }
  /* Progress */
  .swiper-pagination-progressbar {
    background: rgba(0, 0, 0, 0.25);
    position: absolute;
    .swiper-pagination-progressbar-fill {
      background: var(
        --swiper-pagination-color,
        var(--swiper-theme-color)
      ) !important;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transform: scale(0);
      transform-origin: left top;
    }
    .swiper-rtl & .swiper-pagination-progressbar-fill {
      transform-origin: right top;
    }
    .swiper-horizontal > &,
    &.swiper-pagination-horizontal,
    .swiper-vertical > &.swiper-pagination-progressbar-opposite,
    &.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {
      width: 100%;
      height: 4px;
      left: 0;
      top: 0;
    }
    .swiper-vertical > &,
    &.swiper-pagination-vertical,
    .swiper-horizontal > &.swiper-pagination-progressbar-opposite,
    &.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {
      width: 4px;
      height: 100%;
      left: 0;
      top: 0;
    }
  }
  .swiper-pagination-lock {
    display: none;
  }
`;

export const WrapperSlide = styled.button`
  user-select: none;
  height: 312px;
  display: block;
  background-color: white;
  width: 100%;

  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;
